import { render, staticRenderFns } from "./EChartFaltasAluno.vue?vue&type=template&id=5ab82398"
import script from "./EChartFaltasAluno.vue?vue&type=script&lang=js"
export * from "./EChartFaltasAluno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports